module.exports = __webpack_public_path__ + "static/media/r43.9087ac5c.jpg";